import { VitalRangeModel } from "@core/models/vitalRangeModel";

 
export class VitalsRangeAction {
  static readonly type = '[VitalsRange] VitalsRange';

  constructor(public payload: VitalRangeModel[]) {}
}